<template>
  <div>
    <div class="label_PFormInputTextSearch" v-if="label != ''">{{ label }}</div>
    <div :class="classComp" @click="click" @mouseleave="mouseleave">
      <PIcon
        icon="search"
        type="material"
        size="20"
        class="searchIcon_PFormInputTextSearch"
      ></PIcon>

      <input
        ref="inputRef"
        type="text"
        v-model="valueLocal"
        class="searchInput_PFormInputTextSearch"
        @input="input"
        :readonly="readonly"
        v-show="showInput"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: { PIcon },
})
export class PFormInputTextSearch extends Vue {
  @Prop({ required: true }) value!: string;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = this.value;
  }
  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: true }) show!: boolean;
  @Ref("inputRef") readonly inputRef!: any;
  valueLocal = "";
  showInput = false;
  mounted(): void {
    this.showInput = this.show;
  }
  get classComp(): string {
    if (this.valueLocal != "") {
      return "search_PFormInputTextSearch active_PFormInputTextSearch";
    } else {
      return "search_PFormInputTextSearch";
    }
  }
  input(): void {
    this.$emit("input", this.valueLocal);
  }
  click(): void {
    this.showInput = true;
    this.$nextTick(() => {
      this.inputRef.focus();
    });
  }
  mouseleave(): void {
    if (this.valueLocal === "" && !this.show) {
      this.showInput = false;
    }
  }
}
export default PFormInputTextSearch;
</script>
<style scoped>
.label_PFormInputTextSearch {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
}

.search_PFormInputTextSearch {
  padding: 4px 4px 4px 4px;
  border-radius: 20px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.searchIcon_PFormInputTextSearch {
  cursor: pointer;
}
.searchInput_PFormInputTextSearch {
  width: 100%;
  border: none;
  margin-left: 5px;
}
.active_PFormInputTextSearch {
  border: solid 1px #d7b000;
}
</style>
